// packages
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// components
import Pill from "../../../common/Pill";

// styles
import styles from "./BrokerRefundCustomer.module.scss";

const BrokerRefundCustomer = () => {
  const { t } = useTranslation();
  return (
    <Pill
      styleName={"doneLight"}
      Lefticon={<img src={"../../../assets/images/svg/money.svg"} />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_broker_refund_customer_status")}
      </p>
    </Pill>
  );
};

export default BrokerRefundCustomer;
